import React from 'react';
import { retrieve_schedule } from '../api/schedule';
import { retrieve_reservation_setting } from '../api/reservationSetting';
import {
  type RetrieveReservationSettingType,
  type RetrieveScheduleType,
} from 'types/API';
import { type ScheduleType } from 'types/Schema';
import { type ReservationSettingTypeType } from 'types/ReservationSetting';

export const useReservationData = (): {
  schedule: ScheduleType[];
  reservationSetting: ReservationSettingTypeType;
} => {
  const [schedule, setSchedule] = React.useState<ScheduleType[]>([]);
  const [reservationSetting, setReservationSetting] =
    React.useState<ReservationSettingTypeType>({});

  const afterRetrieveSchedule = (data: RetrieveScheduleType): void => {
    const scheduleList = data?.items;
    if (scheduleList !== null && scheduleList !== undefined) {
      setSchedule(scheduleList);
    }
  };

  const afterRetrieveReservationSetting = (
    data: RetrieveReservationSettingType
  ): void => {
    const resSetting = data.item;
    setReservationSetting(resSetting);
  };

  React.useEffect(() => {
    void retrieve_reservation_setting(afterRetrieveReservationSetting);
    void retrieve_schedule(afterRetrieveSchedule);
  }, []);

  return {
    schedule,
    reservationSetting,
  };
};
